/*************************************************/
/* Downloads                                     */
/*************************************************/
export function downloads() {
    const init = () => {
        document.addEventListener('DOMContentLoaded', () => {
            const dropdowns = document.querySelectorAll('.downloads__filter-section--filters');

            dropdowns.forEach((dropdown) => {
                dropdown.addEventListener('change', () => {
                    handleDropdownChange(dropdown.value);
                });
            });
        });
    };

    const handleDropdownChange = (selectedValue) => {
        if (selectedValue !== "All") {
            window.scrollTo({
                top: document.querySelector("#" + selectedValue).offsetTop,
                behavior: 'smooth',
            });
        }
    };

    init();
}

